import isCheckoutUrl from './isCheckoutUrl';

export default function getSellerCheckoutFromUrl(href) {
  const url = new URL(href);

  if (!isCheckoutUrl(url.origin)) {
    return [];
  }

  return url.pathname
    .replace('/checkout/', '/')
    .replace('/c/', '/')
    .replace('/s/', '/')
    .replace('/overlay/', '/')
    .replace('/embed/', '/')
    .split('/')
    .filter(Boolean);
}
